import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { COLUMNS } from '../constants';

export const isColumns = isElementType(COLUMNS);
